import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Stack } from '@chakra-ui/react';
import { useGetSignInServiceEmail, useInitiateLogin } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import {
  AuthSuggestion,
  DesktopAuthHeader,
  SERVICE_CARD_BORDER_RADIUS,
} from 'components';

import { Form } from './components';

const Login: React.FC = () => {
  const { t } = useTranslation('component.auth.login');
  const navigate = useNavigate();

  const { mutateAsync: submit, isPending: isSubmitting } = useInitiateLogin();
  const [searchParams] = useSearchParams();

  const { client_email, system_identifier } = useGetSignInServiceEmail();

  const SYSTEM_IDENTIFIER = system_identifier
    ? '&system_identifier=' + system_identifier.toUpperCase()
    : '';

  return (
    <Stack w="100%" align="stretch" gap={{ base: 6, md: 8 }}>
      <DesktopAuthHeader title={t('loginToMagix')} titleAlign="center" />
      <Box
        bg="dark"
        borderWidth="1px"
        borderColor="rgba(255,255,255,0.08)"
        borderRadius={SERVICE_CARD_BORDER_RADIUS}
        px={{ base: 5, md: 7 }}
        py={{ base: 6, md: 8 }}
        w="100%"
      >
        <Form
          isSubmitting={isSubmitting}
          onButton={(data) =>
            submit(data).then((res) => {
              if (res?.token) {
                navigate(
                  // eslint-disable-next-line max-len
                  `${routes.auth.verification.url}?token=${res.token}&username=${data.username}&return_url=${searchParams.get('return_url') || ''}${SYSTEM_IDENTIFIER}`
                );
              }
            })
          }
          defaultEmail={client_email}
        />
      </Box>
      <AuthSuggestion include={['forget-password', 'sign-up']} />
    </Stack>
  );
};

export default Login;
